module.exports = __webpack_public_path__ + "img/ClassicAmericanCar.18a025fe.jpg";